module.exports = __webpack_public_path__ + "img/hd_logo.67627ad6.png";